import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import useAuth from '../../../Hooks/useAuth';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const BookingModal = ({openBooking,booking,date,handleBookingClose,setBookingSuccess}) => {
    const{name,time}=booking;
    const {user}=useAuth();

    const initialInfo={patientName:user.displayName,email:user.email,phone:''}
    const [bookingInfo,setBookingInfo]=useState(initialInfo);

const handleOnBlur=e=>{

  const field=e.target.name;
  const value=e.target.value;
  const newInfo={...bookingInfo};
  newInfo[field]=value;
  setBookingInfo(newInfo);
  console.log(newInfo);

}

    const handleBookingSubmit=e=>{
      const appointment={...bookingInfo,time,serviceName:name,
      date:date.toLocaleDateString()
       
      };
      
     
      fetch('https://tranquil-lake-06151.herokuapp.com/appointments',{
        method:'POST',
        headers:{'content-type':'application/json'},
        body:JSON.stringify(appointment)
      }).then(res=>res.json())
      .then(data=>{
        if(data.insertedId){
          setBookingSuccess(true)


          handleBookingClose();
        }
      })


      // collectdata
      // send to the sarver 
      
      
      e.preventDefault();

    }
    return (
        <Modal
        open={openBooking}
        onClose={handleBookingClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
           {name}
          </Typography>
         
          <form onSubmit={handleBookingSubmit}>
          <TextField
           disabled
           sx={{width:'95%',margin:1}}
          id="outlined-size-small"
          defaultValue={time}
          size="small"
        />
          <TextField
           
           sx={{width:'95%',margin:1}}
          id="outlined-size-small"
          defaultValue={user.displayName}
          size="small"
          name="patientName"
          onBlur={handleOnBlur}
        />
          <TextField
           
           sx={{width:'95%',margin:1}}
          id="outlined-size-small"
          defaultValue={user.email}
          size="small"
          name="email"
          onBlur={handleOnBlur}
        />
          <TextField
           
           sx={{width:'95%',margin:1}}
          id="outlined-size-small"
          defaultValue="Your Phone Number"
          size="small"
          name="phone"
          onBlur={handleOnBlur}
        />
          <TextField
          disabled
          sx={{width:'95%',margin:1}}
          id="outlined-size-small"
          defaultValue={date.toDateString()}
          size="small"
        />
        <Button type="submit" variant="contained">Submit</Button>
          

          </form>
        </Box>
      </Modal>
    );
};

export default BookingModal;